<div class="outer-container">
  <div class="inner-container">
    <div class="centered-content">
      <div *ngFor="let header of (( headerLines | async).text)" [innerHtml]="header | translate"></div>
    </div>
  </div>
</div>
